import React from "react";

export const BrandingContext = React.createContext({});

export const BrandingProvider = BrandingContext.Provider;
